/**
 * Yotpo Reviews – product page layout adjustments
 * Moves Write A Review button and review date between panels for desktop/mobile.
 * Attaches click-to-scroll from .yotpo-widget-instance to #yotpo-reviews-main-widget.
 * Adds "Review for <product name> in <color>" metadata directly under review stars.
 * Used by sections/product-information.liquid.
 */
(function () {
  var boundScrollInstances = new WeakSet();
  var reviewOriginById = new Map();
  var reviewOriginResolutionPromises = new Map();
  var yotpoGoUrlCache = new Map();
  var yotpoInterceptorsInstalled = false;
  var hasRequestedInitialReviewsPayload = false;
  var currentYotpoProductName = '';

  var COLOR_KEYS = ['color', 'colour', 'couleur'];

  /** @param {Element} instance */
  function hasZeroReviews(instance) {
    var btn = instance.querySelector(
      'button.yotpo-sr-bottom-line-button[aria-label*="total 0 reviews"]',
    );
    return Boolean(btn);
  }

  function isReviewFormModalOpen() {
    return Boolean(document.querySelector('.modal-backdrop.yotpo-review-form-modal'));
  }

  /** @param {Element | null} target
   *  @param {Element} instance */
  function isZeroReviewsCtaClick(target, instance) {
    if (!target || !target.closest) return false;
    var trigger = target.closest(
      'button.yotpo-sr-bottom-line-button[aria-label*="total 0 reviews"]',
    );
    return Boolean(trigger && instance.contains(trigger));
  }

  function openWriteReviewForm() {
    if (isReviewFormModalOpen()) return;
    var reviewsWidget = document.getElementById('yotpo-reviews-main-widget');
    if (!reviewsWidget) return;
    var writeBtn = /** @type {HTMLElement|null} */ (
      reviewsWidget.querySelector('.yotpo-new-review-btn-wrapper .yotpo-new-review-btn')
    );
    if (!writeBtn) return;
    var btn = writeBtn;
    setTimeout(function () {
      if (isReviewFormModalOpen()) return;
      btn.click();
    }, 600);
  }

  /** @param {Element} instance */
  function isReviewsWidgetInstance(instance) {
    return Boolean(
      instance.querySelector('#yotpo-reviews-main-widget') ||
      instance.closest('#yotpo-reviews-main-widget'),
    );
  }

  function updateScrollAffordance() {
    var instances = document.querySelectorAll('.yotpo-widget-instance');
    instances.forEach(function (instance) {
      /** @type {HTMLElement} */ (instance).style.cursor = isReviewsWidgetInstance(instance)
        ? ''
        : 'pointer';
    });
  }

  function attachScrollToReviews() {
    var instances = document.querySelectorAll('.yotpo-widget-instance');
    instances.forEach(function (instance) {
      if (boundScrollInstances.has(instance)) return;
      boundScrollInstances.add(instance);
      instance.addEventListener('click', function (event) {
        var target = /** @type {Element | null} */ (event.target);
        if (isReviewFormModalOpen()) {
          return;
        }
        if (target && target.closest && target.closest('#yotpo-reviews-main-widget')) {
          return;
        }
        if (hasZeroReviews(instance)) {
          if (!isZeroReviewsCtaClick(target, instance)) {
            return;
          }
          openWriteReviewForm();
          return;
        }
        var reviewsWidget = document.getElementById('yotpo-reviews-main-widget');
        if (reviewsWidget) {
          reviewsWidget.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
    updateScrollAffordance();
  }
  function moveYotpoReviewButton() {
    var summary = document.querySelector('.yotpo-bottom-line-summary');
    var btnWrapper = document.querySelector('.yotpo-new-review-btn-wrapper');
    if (summary && btnWrapper && summary.parentNode && summary.nextElementSibling !== btnWrapper) {
      summary.parentNode.insertBefore(btnWrapper, summary.nextSibling);
      return true;
    }
    return false;
  }

  function placeDateInInfoBox() {
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review');
    var moved = 0;
    reviews.forEach(function (review) {
      var reviewer = review.querySelector('.yotpo-review-left-panel .yotpo-reviewer');
      var dateEl = review.querySelector('.yotpo-review-date');
      if (reviewer && dateEl && !reviewer.contains(dateEl)) {
        reviewer.appendChild(dateEl);
        moved++;
      }
    });
    return moved > 0;
  }

  // Below ~480px Yotpo renders the key-value sizes inside the center panel's
  // mobile questions panel instead of the left panel, so it falls outside the
  // grey info box. Move it into the left panel (after the reviewer) whenever it
  // isn't already there, leaving the range bars in the main content column.
  function placeSizesInInfoBox() {
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review');
    var moved = 0;
    reviews.forEach(function (review) {
      var left = review.querySelector('.yotpo-review-left-panel');
      var keyValue = review.querySelector('.yotpo-review-key-value-question');
      if (left && keyValue && !left.contains(keyValue)) {
        left.appendChild(keyValue);
        moved++;
      }
    });
    return moved > 0;
  }

  function styleKeyValueRows() {
    var desktop = window.innerWidth > 1079;
    var blocks = document.querySelectorAll(
      '#yotpo-reviews-main-widget .yotpo-review-key-value-question',
    );
    blocks.forEach(function (el) {
      var block = /** @type {HTMLElement} */ (el);
      if (!desktop) {
        block.style.removeProperty('grid-template-rows');
        return;
      }
      var titles = block.querySelectorAll('.yotpo-custom-questions-title').length;
      if (titles > 0) {
        block.style.gridTemplateRows = 'repeat(' + titles + ', auto)';
      }
    });
  }

  function styleRangeQuestionBars() {
    var bars = document.querySelectorAll(
      '.yotpo-custom-questions-range-question-wrapper .yotpo-progress-bar',
    );
    bars.forEach(function (bar) {
      var score = /** @type {HTMLElement | null} */ (
        bar.querySelector('.yotpo-progress-bar-score')
      );
      if (!score) return;

      var left = parseFloat(score.style.marginLeft) || 0;
      var width = parseFloat(score.style.width) || 0;
      var fillEnd = left + width;
      var bucket = Math.min(5, Math.max(1, Math.ceil(fillEnd / 20)));
      var nextBucket = String(bucket);

      if (bar.getAttribute('data-fit-bucket') !== nextBucket) {
        bar.setAttribute('data-fit-bucket', nextBucket);
      }
    });
  }

  function normalizeColorKey(value) {
    return (value || '').toString().trim().toLowerCase();
  }

  function normalizeProductPath(urlLike) {
    if (!urlLike) return '';
    try {
      return new URL(urlLike, window.location.origin).pathname.replace(/\/$/, '');
    } catch (_error) {
      return '';
    }
  }

  function toHandle(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function toTitleCaseFromSlug(value) {
    if (!value) return '';
    return value
      .split('-')
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(' ');
  }

  function extractColorFromProductVariants(productVariants) {
    if (!productVariants || typeof productVariants !== 'object') return '';
    var entries = Object.entries(productVariants);
    for (var i = 0; i < entries.length; i++) {
      var key = entries[i][0];
      var value = entries[i][1];
      if (!value) continue;
      if (COLOR_KEYS.indexOf(key.toLowerCase()) !== -1) {
        return value.toString().trim();
      }
    }
    return '';
  }

  function extractColorFromCustomFields(customFields) {
    if (!customFields || typeof customFields !== 'object') return '';
    var fields = Object.values(customFields);
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (!field || typeof field !== 'object') continue;
      var title = (field.title || '').toString().toLowerCase();
      if (title.indexOf('color') === -1 && title.indexOf('colour') === -1) continue;
      var value = field.value == null ? '' : field.value.toString().trim();
      if (value) return value;
    }
    return '';
  }

  function deriveColorFromHandle(pathname, productName) {
    if (!pathname) return '';
    var handle = pathname.split('/').filter(Boolean).pop() || '';
    if (!handle) return '';

    var baseHandle = toHandle(productName);
    var colorSlug = '';

    if (baseHandle && handle.indexOf(baseHandle + '-') === 0) {
      colorSlug = handle.slice(baseHandle.length + 1);
    }

    if (!colorSlug) {
      var parts = handle.split('-');
      if (parts.length > 1) {
        colorSlug = parts[parts.length - 1];
      }
    }

    return toTitleCaseFromSlug(colorSlug);
  }

  function extractReviewOriginData(review) {
    if (!review || typeof review !== 'object') return null;

    var groupingData = review.groupingData || {};
    var syndicationData = review.syndicationData || {};
    var bundledProductData = review.bundledProductData || {};

    var productName =
      groupingData.productName ||
      syndicationData.productName ||
      bundledProductData.productName ||
      '';
    var productUrl =
      groupingData.productUrl || syndicationData.productUrl || bundledProductData.productUrl || '';
    var imageUrl =
      groupingData.imageUrl || syndicationData.imageUrl || bundledProductData.imageUrl || '';
    var color =
      extractColorFromProductVariants(review.productVariants) ||
      extractColorFromCustomFields(review.customFields) ||
      '';

    if (!productName && !productUrl && !imageUrl && !color) return null;

    return {
      productName: productName,
      productUrl: productUrl,
      imageUrl: imageUrl,
      color: color,
      finalProductUrl: '',
    };
  }

  function cacheYotpoReviewsPayload(payload) {
    if (!payload || !Array.isArray(payload.reviews)) return;

    if (Array.isArray(payload.products) && payload.products.length) {
      var productName = payload.products[0] && payload.products[0].name;
      if (typeof productName === 'string' && productName.trim()) {
        currentYotpoProductName = productName.trim();
      }
    }

    var changed = false;
    payload.reviews.forEach(function (review) {
      if (!review || review.id == null) return;
      var reviewId = String(review.id);
      var nextOrigin = extractReviewOriginData(review);
      if (!nextOrigin) return;

      var currentOrigin = reviewOriginById.get(reviewId) || {};
      var mergedOrigin = Object.assign({}, currentOrigin, nextOrigin);

      if (
        mergedOrigin.productName !== currentOrigin.productName ||
        mergedOrigin.productUrl !== currentOrigin.productUrl ||
        mergedOrigin.imageUrl !== currentOrigin.imageUrl ||
        mergedOrigin.color !== currentOrigin.color
      ) {
        reviewOriginById.set(reviewId, mergedOrigin);
        changed = true;
      }
    });

    if (changed) {
      scheduleApply();
    }
  }

  function isYotpoReviewsRequestUrl(urlLike) {
    if (!urlLike) return false;
    var urlText = urlLike.toString();
    return urlText.indexOf('api-cdn.yotpo.com') !== -1 && urlText.indexOf('/reviews') !== -1;
  }

  function extractRequestUrl(resource) {
    if (typeof resource === 'string') return resource;
    if (resource && typeof resource.url === 'string') return resource.url;
    return '';
  }

  function installYotpoResponseInterceptors() {
    if (yotpoInterceptorsInstalled) return;
    yotpoInterceptorsInstalled = true;

    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function (resource, init) {
        var requestUrl = extractRequestUrl(resource);
        return originalFetch.call(this, resource, init).then(function (response) {
          if (response && isYotpoReviewsRequestUrl(requestUrl)) {
            response
              .clone()
              .json()
              .then(cacheYotpoReviewsPayload)
              .catch(function () {});
          }
          return response;
        });
      };
    }

    var originalXhrOpen = XMLHttpRequest.prototype.open;
    var originalXhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vbYotpoRequestUrl = typeof url === 'string' ? url : '';
      return originalXhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (isYotpoReviewsRequestUrl(this.__vbYotpoRequestUrl)) {
        this.addEventListener('load', function () {
          try {
            var payload = JSON.parse(this.responseText);
            cacheYotpoReviewsPayload(payload);
          } catch (_error) {}
        });
      }
      return originalXhrSend.apply(this, arguments);
    };
  }

  function getYotpoStorefrontContext() {
    var widgetsContainer = window.yotpoWidgetsContainer;
    var guids = widgetsContainer && widgetsContainer.guids;
    if (!guids || typeof guids !== 'object') return null;

    var guidValues = Object.values(guids);
    for (var i = 0; i < guidValues.length; i++) {
      var instance = guidValues[i];
      var productFilters = instance && instance.product_filters_data;
      if (!productFilters) continue;
      if (productFilters.storeId && productFilters.externalId) {
        return {
          storeId: productFilters.storeId,
          productExternalId: productFilters.externalId,
        };
      }
    }
    return null;
  }

  function requestInitialYotpoReviewsPayload() {
    if (hasRequestedInitialReviewsPayload) return;

    var context = getYotpoStorefrontContext();
    if (!context) return;
    hasRequestedInitialReviewsPayload = true;

    var requestUrl =
      'https://api-cdn.yotpo.com/v3/storefront/store/' +
      encodeURIComponent(context.storeId) +
      '/product/' +
      encodeURIComponent(context.productExternalId) +
      '/reviews?page=1&perPage=20&sort=rating,date,badge,images';

    fetch(requestUrl, { mode: 'cors', credentials: 'omit' })
      .then(function (response) {
        if (!response.ok) {
          hasRequestedInitialReviewsPayload = false;
          return null;
        }
        return response.json();
      })
      .then(function (payload) {
        if (payload) cacheYotpoReviewsPayload(payload);
      })
      .catch(function () {
        hasRequestedInitialReviewsPayload = false;
      });
  }

  function getReviewSwatchMaps() {
    var byColor = new Map();
    var byPath = new Map();
    var swatchInputs = document.querySelectorAll(
      '.variant-option__button-label--has-swatch input[data-connected-product-url]',
    );

    swatchInputs.forEach(function (input) {
      var label = input.closest('.variant-option__button-label--has-swatch');
      if (!label) return;

      var swatch = label.querySelector('.swatch');
      if (!swatch) return;

      var connectedProductUrl = input.dataset.connectedProductUrl || '';
      var colorName =
        (label.dataset && label.dataset.colorName) ||
        input.getAttribute('aria-label') ||
        input.value ||
        '';
      var normalizedColor = normalizeColorKey(colorName);
      var path = normalizeProductPath(connectedProductUrl);
      var swatchBackground = swatch.style.getPropertyValue('--swatch-background').trim();
      var swatchFocalPoint = swatch.style.getPropertyValue('--swatch-focal-point').trim();
      var swatchData = {
        color: colorName,
        productUrl: connectedProductUrl,
        swatchBackground: swatchBackground,
        swatchFocalPoint: swatchFocalPoint,
      };

      if (normalizedColor && !byColor.has(normalizedColor)) {
        byColor.set(normalizedColor, swatchData);
      }
      if (path && !byPath.has(path)) {
        byPath.set(path, swatchData);
      }
    });

    return {
      byColor: byColor,
      byPath: byPath,
    };
  }

  function getCurrentProductName() {
    if (currentYotpoProductName) {
      return currentYotpoProductName;
    }

    var productTitle =
      document.querySelector('main .product-title-pdp') ||
      document.querySelector('main h1') ||
      document.querySelector('h1');
    if (!productTitle || !productTitle.textContent) return '';

    var nextName = productTitle.textContent.trim();
    if (!nextName) return '';
    if (nextName.length > 140) return '';
    if (nextName.toLowerCase().indexOf('is currently unavailable') !== -1) return '';
    return nextName;
  }

  function toResolvableYotpoUrl(urlLike) {
    if (!urlLike) return '';
    try {
      var parsed = new URL(urlLike, window.location.origin);
      if (parsed.hostname === 'yotpo.com') {
        parsed.hostname = 'api.yotpo.com';
      }
      return parsed.toString();
    } catch (_error) {
      return urlLike;
    }
  }

  function resolveYotpoProductUrl(urlLike) {
    if (!urlLike) return Promise.resolve('');
    if (yotpoGoUrlCache.has(urlLike)) {
      return Promise.resolve(yotpoGoUrlCache.get(urlLike));
    }

    return fetch(toResolvableYotpoUrl(urlLike), {
      mode: 'cors',
      redirect: 'follow',
      credentials: 'omit',
    })
      .then(function (response) {
        var resolved = response && response.url ? response.url : urlLike;
        yotpoGoUrlCache.set(urlLike, resolved);
        return resolved;
      })
      .catch(function () {
        yotpoGoUrlCache.set(urlLike, urlLike);
        return urlLike;
      });
  }

  function resolveReviewColorway(reviewId, swatchByPath) {
    if (!reviewId || reviewOriginResolutionPromises.has(reviewId)) return;
    var origin = reviewOriginById.get(reviewId);
    if (!origin || !origin.productUrl) return;

    var promise = resolveYotpoProductUrl(origin.productUrl)
      .then(function (resolvedUrl) {
        var latest = reviewOriginById.get(reviewId);
        if (!latest) return;

        var nextOrigin = Object.assign({}, latest, {
          finalProductUrl: resolvedUrl || latest.productUrl,
        });

        if (!nextOrigin.color) {
          var path = normalizeProductPath(nextOrigin.finalProductUrl);
          var swatchFromPath = path ? swatchByPath.get(path) : null;
          if (swatchFromPath && swatchFromPath.color) {
            nextOrigin.color = swatchFromPath.color;
          } else if (path) {
            nextOrigin.color = deriveColorFromHandle(path, nextOrigin.productName);
          }
        }

        reviewOriginById.set(reviewId, nextOrigin);
        scheduleApply();
      })
      .finally(function () {
        reviewOriginResolutionPromises.delete(reviewId);
      });

    reviewOriginResolutionPromises.set(reviewId, promise);
  }

  function getFallbackOriginDataFromDom(review) {
    var relatedLink = review.querySelector('.yotpo-related-product-name-link');
    if (!relatedLink) return null;
    var productName = relatedLink.textContent ? relatedLink.textContent.trim() : '';
    if (!productName) return null;
    return {
      productName: productName,
      productUrl: '',
      imageUrl: '',
      color: '',
      finalProductUrl: '',
    };
  }

  function createReviewOriginRow(reviewId, origin) {
    var review = document.querySelector(
      '#yotpo-reviews-main-widget .yotpo-review[data-id="' + reviewId + '"]',
    );
    if (!review) return;

    var ratingTitle = review.querySelector('.yotpo-review-rating-title');
    if (!ratingTitle) return;

    var productName = (origin.productName || '').trim();
    var reviewedColor = (origin.color || '').trim();

    if (!productName || !reviewedColor) {
      review.classList.remove('vb-yotpo-review-origin-ready');
      var existingRow = ratingTitle.querySelector('.vb-yotpo-review-origin');
      if (existingRow) existingRow.remove();
      return;
    }

    var originRow = ratingTitle.querySelector('.vb-yotpo-review-origin');
    if (!originRow) {
      originRow = document.createElement('p');
      originRow.className = 'vb-yotpo-review-origin';
      ratingTitle.appendChild(originRow);
    }

    // Build this row once, then only update changed text values.
    // Replacing DOM nodes on every mutation caused hover underline restarts.
    if (originRow.dataset.vbStructured !== 'true') {
      originRow.textContent = '';

      var prefixNode = document.createElement('span');
      prefixNode.className = 'vb-yotpo-review-origin__prefix';
      originRow.appendChild(prefixNode);

      var initialColorText = document.createElement('span');
      initialColorText.className = 'vb-yotpo-review-origin__color-link';
      originRow.appendChild(initialColorText);

      originRow.dataset.vbStructured = 'true';
    }

    var prefix = originRow.querySelector('.vb-yotpo-review-origin__prefix');
    var colorText = originRow.querySelector('.vb-yotpo-review-origin__color-link');
    if (!prefix || !colorText) return;

    var nextPrefixText = 'Review for ' + productName + ' in ';
    if (prefix.textContent !== nextPrefixText) {
      prefix.textContent = nextPrefixText;
    }
    if (colorText.textContent !== reviewedColor) {
      colorText.textContent = reviewedColor;
    }
    review.classList.add('vb-yotpo-review-origin-ready');
  }

  function applyReviewOrigins() {
    var reviews = document.querySelectorAll('#yotpo-reviews-main-widget .yotpo-review[data-id]');
    if (!reviews.length) return;

    var swatchMaps = getReviewSwatchMaps();
    var swatchByColor = swatchMaps.byColor;
    var swatchByPath = swatchMaps.byPath;
    var currentProductName = getCurrentProductName();
    var currentProductPath = normalizeProductPath(window.location.pathname);
    var currentSwatch = currentProductPath ? swatchByPath.get(currentProductPath) : null;
    var currentSwatchColor = normalizeColorKey(currentSwatch && currentSwatch.color);
    var hasMissingMetadata = false;

    reviews.forEach(function (review) {
      var reviewId = review.getAttribute('data-id');
      if (!reviewId) return;

      if (!reviewOriginById.has(reviewId)) {
        var fallbackOrigin = getFallbackOriginDataFromDom(review);
        if (fallbackOrigin) {
          reviewOriginById.set(reviewId, fallbackOrigin);
        }
      }

      var origin = reviewOriginById.get(reviewId);
      if (!origin) {
        hasMissingMetadata = true;
        return;
      }

      if (origin.productUrl && !origin.finalProductUrl) {
        resolveReviewColorway(reviewId, swatchByPath);
      }

      var normalizedColor = normalizeColorKey(origin.color);
      var swatchData = normalizedColor ? swatchByColor.get(normalizedColor) : null;
      if (!swatchData && origin.finalProductUrl) {
        swatchData = swatchByPath.get(normalizeProductPath(origin.finalProductUrl));
      }
      if (!swatchData && origin.productUrl) {
        swatchData = swatchByPath.get(normalizeProductPath(origin.productUrl));
      }

      var nextOrigin = Object.assign({}, origin);
      if (!nextOrigin.productName && currentProductName) {
        nextOrigin.productName = currentProductName;
      }
      if (!nextOrigin.color && swatchData && swatchData.color) {
        nextOrigin.color = swatchData.color;
      }
      if (!nextOrigin.productUrl && swatchData && swatchData.productUrl) {
        nextOrigin.productUrl = swatchData.productUrl;
      }

      // Some "native" reviews do not include grouping/syndication URLs in Yotpo's payload.
      // If the review color matches the currently viewed swatch, safely fall back to this PDP.
      if (
        !nextOrigin.productUrl &&
        normalizedColor &&
        currentSwatchColor &&
        normalizedColor === currentSwatchColor
      ) {
        nextOrigin.productUrl = window.location.pathname;
      }

      if (!nextOrigin.color && origin.finalProductUrl) {
        nextOrigin.color = deriveColorFromHandle(
          normalizeProductPath(origin.finalProductUrl),
          origin.productName,
        );
      }

      if (swatchData) {
        nextOrigin.swatchBackground = swatchData.swatchBackground;
        nextOrigin.swatchFocalPoint = swatchData.swatchFocalPoint;
      } else {
        nextOrigin.swatchBackground = '';
        nextOrigin.swatchFocalPoint = '';
      }

      if (!nextOrigin.swatchBackground && nextOrigin.imageUrl) {
        nextOrigin.swatchBackground = 'url(' + nextOrigin.imageUrl + ')';
      }

      reviewOriginById.set(reviewId, nextOrigin);

      createReviewOriginRow(reviewId, nextOrigin);

      if (!nextOrigin.color || !(nextOrigin.finalProductUrl || nextOrigin.productUrl)) {
        hasMissingMetadata = true;
      }
    });

    if (hasMissingMetadata) {
      requestInitialYotpoReviewsPayload();
    }
  }

  function runYotpoLayout() {
    moveYotpoReviewButton();
    placeDateInInfoBox();
    placeSizesInInfoBox();
    styleKeyValueRows();
    applyReviewOrigins();
  }

  function applyYotpoAdjustments() {
    if (isReviewFormModalOpen()) return;
    runYotpoLayout();
    styleRangeQuestionBars();
    attachScrollToReviews();
  }

  var observer = new MutationObserver(scheduleApply);
  var scheduled = false;

  function observeYotpo() {
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      observer.disconnect();
      if (isReviewFormModalOpen()) {
        observeYotpo();
        return;
      }
      applyYotpoAdjustments();
      observeYotpo();
    });
  }

  installYotpoResponseInterceptors();
  requestInitialYotpoReviewsPayload();
  applyYotpoAdjustments();
  observeYotpo();
  window.addEventListener('resize', scheduleApply);
})();
